import { createLogger } from '@lsk4/log';
// import { createLogger } from './createLogger.js';

export { createLogger };
